const testimonials = [
    {
        full_name : 'Oscar Djamo',
        image: 'assets/img/faces/1.jpg',
        origin: 'france',
        rank: 4,
        review : "Très bon emplacement avec une belle vue sur le fleuve, très propre, personnel agréable. C'était très bien par rapport au prix"
    },
    {
        full_name : 'Emmanuel Bakary',
        image: 'assets/img/faces/2.jpg',
        origin: "ivoryCoast",
        rank: 5,
        review : "Rapport qualité-prix imbattable, le  service impécable et le lieux est très propre. ma destination par excellence lors de mes voyages d'affaire au Cameroun."
    },
    {
        full_name : 'Viktoria Tanaka',
        image: 'assets/img/faces/3.jpg',
        origin: 'usa',
        rank: 4,
        review : 'Cleanliness of all rooms, politeness of all staff, convenient location. I really recommend this hotel.'
    },
    {
        full_name : 'Claude Abanda',
        image: 'assets/img/faces/4.jpg',
        origin: 'belgium',
        rank: 5,
        review : 'Le service à la clientèle était très bon et les gens gentils. Le lieu est vraiment agréable.'
    },
]

export default testimonials